(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('ohDispatches', {
        templateUrl: 'views/components/views/ohDispatches/ohDispatches.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'translateService', 'modalService', 'ohDispatchesService', function ($stateParams, utilityService, translateService, modalService, ohDispatchesService) {
            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            let translations = {
                confirm_title: '',
                reminder_url_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: ''
            };

            vm.model = {
                setting: {},
                itemsListDispatches: []
            };

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            async function loadSetting() {
                vm.model.setting = (await ohDispatchesService.getSetting({
                    argtype: argType,
                    argvalue: argValue
                }))[0];
            }
            
            async function loadDispatches() {
                if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;
                
                return vm.model.itemsListDispatches = await ohDispatchesService.listDispatches({
                    argtype: vm.model.setting.argtype,
                    argvalue: vm.model.setting.argvalue
                });
            }

            vm.openWebLinkDispatch = function (item) {
                if (item.trackandtrace_url > '') {
                    window.open(item.trackandtrace_url);
                } else {
                    modalService.confirm({
                        type: 'warning',
                        title: translations.confirm_title,
                        message: translations.reminder_url_message,
                        okLabel: translations.confirm_ok_label,
                        cancelLabel: translations.confirm_cancel_label
                    });
                }
            }

            vm.$onInit = async function () {
                translate();
                await loadSetting();
                loadDispatches();
            }
        }]
    });
})();
